<template>
  <div class="course-details-tabs">
    <v-tabs
      class="course-details-tabs__tabs"
      v-model="listActiveTab"
      background-color="transparent"
      color="accent"
      @change="changeActiveListTab"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab>Course settings</v-tab>
      <v-tab :disabled="disableSteps">Course steps</v-tab>
    </v-tabs>
    <v-tabs-items
      v-model="listActiveTab"
      class="course-details-tabs__list-tabs-items"
    >
      <v-tab-item>
        <slot name="settings"></slot>
      </v-tab-item>
      <v-tab-item v-if="!disableSteps">
        <slot name="steps"></slot>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
export default {
  name: 'CourseDetailsTabs',
  props: {
    disableSteps: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    listActiveTab: 0,
  }),
  methods: {
    changeActiveListTab(type) {
      let tab = type === 1 ? 'course-steps' : 'course-settings'
      this.$emit('change-tab', tab)
    },
  },
}
</script>

<style lang="scss">
.course-details-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  &__tabs {
    flex: initial;
  }
  &__list-tabs-items {
    height: 100%;
    overflow: visible;
    background-color: transparent !important;
  }
}
</style>
